<template>
  <v-layout style="width:100%;padding:0">
    <v-flex xs12>
      <table style="width:100%;border-spacing:0;padding:0;">
        <tr style="padding:0;">
          <td v-for="(value, key) in features" :key="key"
              v-tooltip:top="{ html: compound[key] ? value.textValidCompound : value.textInvalidCompound }"
              v-bind:style="{ 'text-align':'center', cursor: 'pointer'}">
            <img style="width:30%;max-width:50px;padding:10px 0 0 0;"
              :src="compound[key] ? value.imageValid : value.imageInvalid">
            </img>
          </td>
        </tr>
        <tr>
          <td v-for="(value, key) in features" :key="key"
             v-bind:style="{ 'text-align':'center',
              color:'gray',
              background: compound[key] ? '#C8E6C9' : '#FFCDD2',
              'border-bottom': compound[key] ? '5px solid #66BB6A' : '5px solid #EF5350'}">
          </td>
        </tr>
      </table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['compound', 'features']
}
</script>



// WEBPACK FOOTER //
// PrbFeatures.vue?0f182db6